import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueMask from 'v-mask'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import './assets/css/style.sass'

Vue.config.productionTip = false;


Vue.use(VueMask);



new Vue({
    vuetify,

    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.xs;
        },
        isDebug() {
            return this.debug;
        }
    },
    data() {
        return {
            debug: process.env.NODE_ENV != "production",
            isPreloader: false,
        }
    },
    render: h => h(App)
}).$mount('#app');
